// function mergeArr(arr1,arr2){  //取并集
//     return arr1.concat(arr2).sort((a,b)=>{
//         return a-b;
//     }).filter((val,index,arr)=>{
//         return val != arr[index-1];
//     });
// }


export default {
    taskTplObj:(state)=>{   //任务类型对象
        return state.taskTpl.reduce((obj,item)=>{
            obj[item.id] = item;
            return obj;
        },{});
    },
    currencyObj:(state)=>{  //快币对象
        return state.currencyList.reduce((obj,item)=>{
            obj[item.id] = item;
            return obj;
        },{})
    },
    bonusYearOptions(state){  //分配周期 年份选项
        if(state.allBonusCycle.length == 0){
            return [];
        }

        return state.allBonusCycle.reduce((arr,item)=>{
            if(arr[0] != item.cycle_year){
                arr.unshift(item.cycle_year);
            }
            return arr;
        },[]).sort((a,b)=>a-b);
    },
    codeList(state){   //用户权限列表
        let permission = state.userInfo && state.userInfo.permissionString;
        let str = permission || '';
        return str.split(',').map(val => parseInt(val));
    },
    task_curr(state){  //默认任务币
        return state.currencyList.filter(curr=>{
            return curr.currency_type == 10;
        })[0] || {};
    },
    ticket_curr(state){  //默认罚币
        return state.currencyList.filter(curr=>{
            return curr.currency_type == 20;
        })[0] || {};
    }
}



// WEBPACK FOOTER //
// ./src/store/getters.js